
import {
  getStepsToJoinCampaign,
  JOIN_CAMPAIGN_STEP_TYPE,
} from '@store:web/components/pages/StoryPage/SpecificStory/ui/StepsToJoinCampaign/getStepsToJoinCampaign';

import type {
  StepsToJoinCampaignStep,
} from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import StepsToJoinCampaign from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import { AUTO_LAYER_CAMPAIGN_URL } from './data';

const stepsToJoinAutoLayerCampaign: StepsToJoinCampaignStep[] = [
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.REGISTER_MAGIC_STORE_ACCOUNT,
    JOIN_CAMPAIGN_STEP_TYPE.ADD_EVM_WALLET,
    JOIN_CAMPAIGN_STEP_TYPE.USERNAME_AND_EMAIL,
    JOIN_CAMPAIGN_STEP_TYPE.VERIFY_HUMANITY_LIVENESS,
    JOIN_CAMPAIGN_STEP_TYPE.VISIT_CAMPAIGN_PAGE,
    JOIN_CAMPAIGN_STEP_TYPE.MONITOR_LEADERBOARD,
  ]),
  {
    id: 'claim',
    title: 'Claim will be done directly through your Magic Launchpad Account',
  },
];

const StepToJoinAutoLayerCampaign = () => {
  return (
    <StepsToJoinCampaign
      campaignUrl={AUTO_LAYER_CAMPAIGN_URL}
      steps={stepsToJoinAutoLayerCampaign}
    />
  );
};

export default StepToJoinAutoLayerCampaign;
